import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";
const API_BASE_GETZPASS_URL = process.env.REACT_APP_API_GETZPASS_URL || "";
const API_GETZPASS_KEY = process.env.REACT_APP_API_ACCESS_GETZPASS_KEY || "";

export const helperApi = {
  getShortenLink: async (token: string, value: string) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/GetCampaignShortenLink`,

      { Url: value },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  getPrimaryDomainByBrandId: async (brandId: string) => {
    return axios.post(
      `${API_BASE_GETZPASS_URL}/api/OrderManagement/GetPrimaryDomainByBrandId`,
      {
        ApiAccessKey: API_GETZPASS_KEY,
        BrandIds: brandId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  },
};
